module.exports = __webpack_public_path__ + "static/ms-logo-798f37da7af0ce45551cc3e0adb59ac1.svg";